module.exports = __webpack_public_path__ + "static/logo-gray-91c3ee2a14721c226e281ed5b85b4818.svg";